<script>
	export let href = '';
	export let file = 'resider-logo';

	/**
	 * @param {string} name
	 * @returns {string}
	 */
	function rawSVG(name) {
		const brandAssets = import.meta.glob('../../assets/svg/logos/*.svg', {
			query: '?raw',
			import: 'default',
			eager: true
		});
		return brandAssets[`../../assets/svg/logos/${name}.svg`];
	}

	$: tag = href ? 'a' : 'span';

	$: anchorProps = {
		href: href ?? null
	};
</script>

<svelte:element
	this={tag}
	class="logo"
	role="link"
	tabindex="0"
	{...anchorProps}
	on:click
	on:keydown
>
	{@html rawSVG(file)}
</svelte:element>

<style>.logo{display:flex}.logo :global(svg){height:2rem!important;height:var(--height, 2rem)!important}</style>
